import { select } from "d3";
import { html, render } from "lit";
import { MainPage } from "../../../MainPage";
import { Entidad } from "../../../data/Entidad";
import { DataModuloMain } from "../../../data/ModuloMain";
import { IFinanzaAgrupadorCargos } from "../../../data/entidad/FinanzaAgrupadorCargos";
import { _DICC_ESCUELA } from "../../../data/modulo/Escuela";
import { _DICC_AGRUPADORES, _DICC_AGRUPADORES_FULL, _SvFinanzasObtenerListaAgrupadorCargosByIds } from "../../../data/modulo/FinanzaAgrupadorCargos";
import { _SvFinanzasActualizarCargo, _SvFinanzasNuevoCargo } from "../../../data/modulo/FinanzaCargo";
import { _SvAlumnoCargosNuevoCargoAsignAlumnoNoPlantilla } from "../../../data/modulo/FinanzasAsignaciones";
import { ArrayV2 } from "../../../util/ArrayV2";
import { DateV2 } from "../../../util/DateV2";
import _L from "../../../util/Labels";
import { Button } from "../../controlD3/Button";
import { CalendarioGridCargos } from "../../controlD3/CalendarioGrid/CalendarioGridCargos";
import { FormGenerator } from "../../controlD3/Formulario";
import { ModalThings } from "../../controlD3/ModalThings";
import { NotificacionV2 } from "../../controlD3/NotificacionV2";
import { UIUtilFormat } from "../../util/Format";
import { UIUtilLang } from "../../util/Language";
import { UIUtilTime } from "../../util/Time";
import { UIUtilGeneral } from "../../util/Util";
import { UIUtilViewData } from "../../util/ViewData";
import { CCargoFormActions, CFinanzaCargoFormField, TCargoFormOrigin, TFinanzaCargoDataForm } from "./FinanzaCargoForm";

export namespace UIUtilViewFinanzaCargo {
    import IFinanzaCargo = Entidad.IFinanzaCargo;
    import CCategoriaTipoFinanza = Entidad.CFinanzaCargoCategoria
    import CPeriodicidadCargos = Entidad.CFinanzaCargoPeriodicidadCargos;
    import CTipoValor = Entidad.CFinanzaCargoTipoValor;
    import CAccionPermiso = Entidad.CAccionPermiso;
    import CTipoInteres = Entidad.CFinanzaCargoTipoInteres;
    import CTipoTasa = Entidad.CFinanzasCargoTipoTasa;
    import CFinanzasCargoRecurrenciaRecargo = Entidad.CFinanzasCargoRecurrenciaRecargo;

    const langContextModuleFCargo = "finanzascargo";


    export function _GetStrRecargosCol(datoCargo: Pick<IFinanzaCargo, "TipoRecargo" | "Categoria" | "ValorRecargo" | "TipoInteres" | "TipoTasa" | "IntervaloBloque"> /* & { TipoTasa?: CTipoTasa } */) {
        const esCargoValido = [CCategoriaTipoFinanza.Cargo, CCategoriaTipoFinanza.CargoEntrada, CCategoriaTipoFinanza.CargoSalida]
            .includes(datoCargo.Categoria);
        let str = "";
        if (!esCargoValido || datoCargo.TipoRecargo == CTipoValor.Ninguno) {
            return str;
        }
        if (datoCargo.TipoRecargo == CTipoValor.Porcentaje) {
            const generaInteres = datoCargo.TipoInteres != CTipoInteres.MontoUnico
            str = UIUtilFormat._PercentFmt(datoCargo.ValorRecargo);
            if (generaInteres)
                str += " " + UIUtilViewData._GetStr_TipoInteres(datoCargo.TipoInteres);
            else
                str += " " + _L("finanzascargo.tag_recargounico")
            if (generaInteres) {

                if ([CTipoTasa.Diaria, CTipoTasa.Mensual].includes(datoCargo.TipoTasa)) {
                    str += " (" + UIUtilViewData._GetStr_TipoTasa(datoCargo.TipoTasa) + ")";
                }
                if (datoCargo.IntervaloBloque == CFinanzasCargoRecurrenciaRecargo.Diaria) {
                    str += ", " + _L("finanzascargo.tag_recurrencia_dia").toLowerCase();
                } else if (datoCargo.IntervaloBloque == CFinanzasCargoRecurrenciaRecargo.Mensual) {
                    str += ", " + _L("finanzascargo.tag_recurrencia_mes").toLowerCase();
                }
            }
        } else {
            str = UIUtilFormat._CurrencyFmt(datoCargo.ValorRecargo)
            if (datoCargo.TipoInteres == CTipoInteres.MontoUnico) {
                str += " " + UIUtilViewData._GetStr_TipoInteres(datoCargo.TipoInteres);
            }
            else if (datoCargo.TipoInteres == CTipoInteres.Simple) {
                if (datoCargo.IntervaloBloque == CFinanzasCargoRecurrenciaRecargo.Diaria) {
                    str += " " + _L("finanzascargo.tag_recurrencia_dia")
                } else if (datoCargo.IntervaloBloque == CFinanzasCargoRecurrenciaRecargo.Mensual) {
                    str += " " + _L("finanzascargo.tag_recurrencia_mes")
                }
            }
        }
        return str;
    }

    /** Los descuentos se validan individualmente sobre el resultado de reducción (cargoRestante) del descuento anterior (en el arreglo) sobre el cargo
     * * Nota: Solo el primer elemento del arreglo aplica la validación del descuento sobre el cargo original
     */
    export function _DATA_ValidaDescuentosACargo<T extends Pick<IFinanzaCargo, "TipoValor" | "Valor">>(cargo: number, descuentosInfo: T[]) {
        let descuentoTotal = 0;
        let cargoRestante = cargo;
        let esValido = false;
        let itemsMayoresACargo: T[] = [];
        let itemsEnCero: T[] = [];

        if (cargo > 0) {
            itemsMayoresACargo = descuentosInfo
                .filter(datoDesc => {
                    let descuentoMonto = 0;
                    switch (datoDesc.TipoValor) {
                        case CTipoValor.Monto:
                            descuentoMonto = datoDesc.Valor;
                            descuentoTotal += datoDesc.Valor;

                            break;
                        case CTipoValor.Porcentaje:
                            descuentoMonto = (cargoRestante * (datoDesc.Valor / 100));
                            descuentoMonto = ((descuentoMonto < 0) ? (-1 * descuentoMonto) : descuentoMonto);

                            descuentoTotal += descuentoMonto;
                            // cargoRestante -= descuentoMonto;
                            if (descuentoMonto == 0) {
                                itemsEnCero.push(datoDesc);
                            }
                            break;
                    }

                    if (descuentoMonto > cargoRestante) {
                        // cargoRestante -= descuentoMonto;
                        return true;
                    }

                    // Se ajusta cargo restante para calcular el proximo descuento
                    cargoRestante -= descuentoMonto;
                    return false;
                });

            esValido = ((itemsEnCero.length == 0) && (descuentoTotal <= cargo)); // (cargoRestante >= 0);
        }

        // Es inválido si
        // * Si el valor inicial del cargo es igual a cero
        // * El valor de descuento total es mayor al valor inicial del cargo
        // * Existen items mayores con valores mayores al cargo
        // * Algun descuento (%) es igual a 0. Es porque eventualmente el cargo restante llegó a 0

        return {
            Valido: esValido, // (descuentoTotal <= cargo),
            DescuentoMontoTotal: descuentoTotal,
            DescuentosMayoresACargo: itemsMayoresACargo,
            DescuentosEnCero: itemsEnCero
        }
    }

    /** Los descuentos se validan individualmente sobre el resultado de reducción (cargoRestante) del descuento anterior (en el arreglo) sobre el cargo
     * * Nota: Solo el primer elemento del arreglo aplica la validación del descuento sobre el cargo original
     */
    export function _UI_ValidaDescuentosACargo<T extends Pick<IFinanzaCargo, "TipoValor" | "Valor" | "Nombre">>(cargoValor: number, cargoNombre: string, descuentos: T[]) {
        if (descuentos.length) {
            const validacionRes = _DATA_ValidaDescuentosACargo(cargoValor, descuentos);

            if (!validacionRes.Valido) {
                const fnGetTalLang = (str: string) => UIUtilLang._GetUIString(langContextModuleFCargo, str);

                if (validacionRes.DescuentosMayoresACargo.length) {
                    const descuentosConflict = validacionRes.DescuentosMayoresACargo;
                    if (descuentosConflict.length > 1) {
                        NotificacionV2._Mostrar(
                            fnGetTalLang("notif_conflict_desc_n")
                                .replace("_NDESCS", descuentosConflict.length.toString())
                                .replace("_CARGO", cargoNombre)
                                .replace("_DESCRIP", ""), // Utils.currencyFormater.format(cargoValor)),
                            "ADVERTENCIA"
                        );
                    } else {
                        NotificacionV2._Mostrar(
                            fnGetTalLang("notif_conflict_desc_1")
                                .replace("_DESCUENTO", descuentosConflict[0].Nombre)
                                .replace("_CARGO", cargoNombre)
                                .replace("_DESCRIP", ""), // Utils.currencyFormater.format(cargoValor)),
                            "ADVERTENCIA"
                        );
                    }
                }
                else if (validacionRes.DescuentoMontoTotal > cargoValor) {
                    NotificacionV2._Mostrar(
                        fnGetTalLang("notif_conflict_totdesc")
                            .replace("_CARGO", cargoNombre)
                            .replace("_VALOR", UIUtilFormat._CurrencyFmt(cargoValor)),
                        "ADVERTENCIA"
                    );
                }
                else if (validacionRes.DescuentosEnCero.length) {
                    NotificacionV2._Mostrar(
                        fnGetTalLang("notif_conflict_saldo0")
                            .replace("_CARGO", cargoNombre),
                        "ADVERTENCIA"
                    );
                }
            }

            return validacionRes.Valido
        }
        return false;
    }

    export function _OpenModal_FormAddEditCargo(action: CCargoFormActions, cargo: TFinanzaCargoDataForm, formCargo: FormGenerator<TFinanzaCargoDataForm>, origin: TCargoFormOrigin = "FinanzasCargos", idAlumno?: number) {
        const esEditar = (action == CAccionPermiso.Editar);
        const fromHorasExtras = (origin == "HorasExtras");
        const fromEdoCuenta = (origin == "AlumnosEstadoCuenta");
        const esCargoPreestablecido = [CCategoriaTipoFinanza.CargoEntrada, CCategoriaTipoFinanza.CargoSalida].includes(cargo.Categoria);
        return new Promise<boolean>(resolve => {
            const StepsConfig: ModalThings.IConfigModalToALongProccessItem[] = []
            // Paso 1: FORM CARGO
            const CargoFormStep = _GetStepCargoForm();
            CargoFormStep.Title = _L((esEditar) ? "finanzascargo.action_editcargo" : "finanzascargo.action_addcargo") + " " + (esCargoPreestablecido ? _L("finanzascargo.tag_cargo_preestablecido_info") : "")
            CargoFormStep.Width = 580;
            CargoFormStep.OnDrawContent = (content) => {
                content.append(() => formCargo._Form.node());
            }
            CargoFormStep.OnFocusContent = (content, mt) => {
                Button._EnableButton(mt.BtnRight, true);
            }
            CargoFormStep.OnValideStep = () => {
                if (formCargo._GetIsValidForm()) {
                    if (fromHorasExtras || fromEdoCuenta) {
                        //Usar cuando sea FromHorasExtras
                        cargo = { ...cargo, ...formCargo._Data };
                    }
                    else {
                        //Usar cuando no sea FromHorasExtras
                        cargo = { ...cargo, ...formCargo._Data, MesAplicacion: cargo.MesAplicacion, DiaAplicacion: cargo.DiaAplicacion, DiaMorosidad: cargo.DiaMorosidad, DiaVencimiento: cargo.DiaVencimiento };
                    }
                    return true;
                }
                else {
                    return false;
                }
            }
            // PASO 2: CALENDAR SELECTION
            const CargoAplicacionCalendar = _GetStepCargoAplicacionCalendar();
            CargoAplicacionCalendar.OnDrawContent = (content, mt) => _DrawCalendar(content);
            CargoAplicacionCalendar.OnFocusContent = (content, mt) => {
                mt.Modal._SetTitle(_L(esEditar ? "finanzascargo.ttl_editcargo" : "finanzascargo.ttl_addcargo", cargo.Nombre) + " " + (esCargoPreestablecido ? _L("finanzascargo.tag_cargo_preestablecido_info") : ""));
                let calendarGrid: CalendarioGridCargos.CalendarioGridCargos = content["CalendarGrid"];
                let contCalendar = content.select<HTMLDivElement>(".cont_calendar"); // this.propModal.BodyModal.select<HTMLDivElement>(".cargo_perio0dicidad");
                let contInfo = content.select<HTMLDivElement>(".cont_info");

                let updateInfoCalendar = (periodicidad: Entidad.CFinanzaCargoPeriodicidadCargos, inicioMes: number, apli: number, venc: number, moro: number) => {
                    cargo.MesAplicacion = inicioMes;
                    cargo.DiaAplicacion = apli;
                    cargo.DiaVencimiento = venc;
                    cargo.DiaMorosidad = moro;

                    let textaplicacion = "";
                    let textvencimiento = "";
                    let textmorosidad = "";

                    if (fromEdoCuenta) {
                        const dtFechaAplicacion = new Date(UIUtilTime._GetDateConcatenatedDateTime(formCargo._Data.FechaAplicacion));
                        const dtFechaVencimiento = new Date(dtFechaAplicacion);
                        dtFechaVencimiento.setDate(dtFechaVencimiento.getDate() + cargo.DiaVencimiento);
                        const dtFechaMorosidad = new Date(dtFechaVencimiento);
                        dtFechaMorosidad.setDate(dtFechaMorosidad.getDate() + cargo.DiaMorosidad);

                        textaplicacion = _L("finanzascargo.tag_dtaplica") + ": " + UIUtilTime._DateFormatStandar(dtFechaAplicacion, "d MMM yyyy")
                        textvencimiento = _L("finanzascargo.tag_dtvence") + ": " + UIUtilTime._DateFormatStandar(dtFechaVencimiento, "d MMM yyyy")
                        textmorosidad = _L("finanzascargo.tag_dtmoroso") + ": " + UIUtilTime._DateFormatStandar(dtFechaMorosidad, "d MMM yyyy")
                    } else {
                        textaplicacion = _L("finanzascargo.tag_dtaplica") + ": " + CreateDateDescription(periodicidad, "aplicacion", inicioMes, apli);
                        textvencimiento = _L("finanzascargo.tag_dtvence") + ": " + CreateDateDescription(periodicidad, "vencimiento", inicioMes, venc);
                        textmorosidad = _L("finanzascargo.tag_dtmoroso") + ": " + CreateDateDescription(periodicidad, "morosidad", inicioMes, moro);
                    }


                    if (fromHorasExtras) {
                        formCargo._AsignaData(cargo);
                    }
                    contInfo.select(".tag_1").select(".info").select("label").text(textaplicacion);
                    contInfo.select(".tag_2").select(".info").select("label").text(textvencimiento);
                    contInfo.select(".tag_3").select(".info").select("label").text(textmorosidad);
                }

                if (!calendarGrid) {
                    calendarGrid = new CalendarioGridCargos.CalendarioGridCargos(contCalendar, {
                        ContainerToRedimention: mt.Modal._ModalSelection,
                        OnChangeSomeSelector: (result) => {
                            updateInfoCalendar(cargo.Periodicidad, result.Aplicacion.Month, result.Aplicacion.Days, result.Vencimiento.Days, result.Morocidad.Days);
                        }
                    });
                    content["CalendarGrid"] = calendarGrid;
                } else {
                    if (cargo.Periodicidad != calendarGrid._Periodicidad) {
                        cargo.MesAplicacion = 1;
                        cargo.DiaAplicacion = 1;
                        cargo.DiaVencimiento = 0;
                        cargo.DiaMorosidad = 1;
                        if (fromHorasExtras) {
                            formCargo._AsignaData(cargo);
                        }
                    }
                }

                calendarGrid._Periodicidad = cargo.Periodicidad;
                console.log(cargo.DiaAplicacion, cargo.DiaVencimiento, cargo.DiaMorosidad);
                calendarGrid._SetPosicionSelectores(
                    (cargo.MesAplicacion || 1),
                    (cargo.DiaAplicacion || 1),
                    (cargo.DiaVencimiento || 0),
                    (cargo.DiaMorosidad || 1)
                )

                let initRes = calendarGrid._GetResultSelected();
                updateInfoCalendar(cargo.Periodicidad, initRes.Aplicacion.Month, initRes.Aplicacion.Days, initRes.Vencimiento.Days, initRes.Morocidad.Days);
            }
            // PASO 3: INFO CARGO => ACCEPT CARGO
            const CargoInfoFinalStep = _GetStepCargoInfoFinal();
            CargoInfoFinalStep.Title = _L((esEditar) ? "finanzascargo.tlt_cargoresult" : "finanzascargo.tlt_nuevocargo") + " "
                + (esCargoPreestablecido ? _L("finanzascargo.tag_cargo_preestablecido_info") : "");
            CargoInfoFinalStep.OnDrawContent = (content) => {
                _RenderCargoDescuentoDetails({ ...cargo, DtAplicacion: (fromEdoCuenta) ? new DateV2(UIUtilTime._GetDateConcatenatedDateTime(formCargo._Data.FechaAplicacion)) : null, IdCicloEscolar: (fromEdoCuenta) ? formCargo._Data.IdCicloEscolar : null }, content.node());
            }
            CargoInfoFinalStep.OnFocusContent = (content) => {
                _RenderCargoDescuentoDetails({ ...cargo, DtAplicacion: (fromEdoCuenta) ? new DateV2(UIUtilTime._GetDateConcatenatedDateTime(formCargo._Data.FechaAplicacion)) : null, IdCicloEscolar: (fromEdoCuenta) ? formCargo._Data.IdCicloEscolar : null }, content.node());
            }
            // OnAccept Config
            if (!fromEdoCuenta) {
                CargoInfoFinalStep.OnAccept = async (MT) => {
                    if (esEditar) {
                        let res = await _SvFinanzasActualizarCargo(cargo);
                        if (res.Resultado > 0) {
                            await MainPage._ReloadServiceAndAwaitBool(Entidad.CTipoRequest.FinanzaCargo, cargo.IdEscuela);
                            resolve(true);
                        }
                        else {
                            resolve(false);
                        }
                        return res;
                    } else {
                        interface DataProcess {
                            Resultado: number,
                            ItemData: { idEscuela: number, cargo: TFinanzaCargoDataForm },
                            TipoRequest: Entidad.CTipoRequest
                        }

                        let dataProcess = cargo.IdEscuelas.map<DataProcess>(idEscuela => ({
                            Resultado: -1,
                            ItemData: { idEscuela, cargo },
                            TipoRequest: Entidad.CTipoRequest.FinanzaCargo
                        }));
                        const idAgrupadorSelected = formCargo._GetModelValue("IdAgrupador");
                        // const { idsEscuelasSelectedUsanFacturacion } = _GetCargoFormEscuelasUsaFacturacion(formCargo);
                        await ModalThings._ProccessServiceByServiceFromAArrayIterator(MT, dataProcess, {
                            OnStepAProccess: async (item) => {
                                const agrupador = _DICC_AGRUPADORES.get(item.idEscuela).get(idAgrupadorSelected);
                                const usaFactura = _DICC_ESCUELA.get(item.idEscuela).UsaFactura
                                return _SvFinanzasNuevoCargo({
                                    ...item.cargo,
                                    IdAgrupador: agrupador ? agrupador.Id : 0,
                                    ClaveProdServSAT: usaFactura ? item.cargo.ClaveProdServSAT : "",
                                    NombreProdServSAT: usaFactura ? item.cargo.NombreProdServSAT : "",
                                    ClaveUnidadSAT: usaFactura ? item.cargo.ClaveUnidadSAT : "",
                                    NombreUnidadSAT: usaFactura ? item.cargo.NombreUnidadSAT : "",
                                    IdEscuela: item.idEscuela,
                                });
                            },
                            AccionToHttpMessage: "NuevoCargoV2",
                            OnError_GetItemDataTag: (item, container) => `${DataModuloMain._GetItemDataById(Entidad.CTipoRequest.Escuela, item.idEscuela).Nombre}`,
                        }).catch((err) => {
                            console.log(err);
                            return null;
                        });

                        let arrDataProcess = new ArrayV2<DataProcess>()._Push(...dataProcess);
                        let nReloadErr = 0;
                        await arrDataProcess._ForEachAwait(async (d) => {
                            if (d.Resultado > 0) {
                                await MainPage._ReloadServiceAndAwait(Entidad.CTipoRequest.FinanzaCargo, d.ItemData.idEscuela).catch((err) => {
                                    nReloadErr++;
                                });
                            }
                        });
                        if (nReloadErr > 0) NotificacionV2._Mostrar(UIUtilLang._GetUIString("general", "notif_fail_infoupdate") + "", "ADVERTENCIA");

                        MT.Modal._Ocultar();
                        (dataProcess.filter(d => d.Resultado < 1).length) ? resolve(false) : resolve(true);
                        await UIUtilGeneral._Sleep(300);
                    }
                }
            }
            else {
                CargoInfoFinalStep.OnAccept = async (mt) => {
                    const res = await _SvAlumnoCargosNuevoCargoAsignAlumnoNoPlantilla(
                        cargo,
                        {
                            idAlumno,
                            idCicloEscolar: formCargo._Data.IdCicloEscolar,
                            strDtInicio: new DateV2(UIUtilTime._GetDateConcatenatedDateTime(formCargo._Data.FechaAplicacion))._ToISOLocalString(),
                            strDtfin: null,
                            prodServ: {
                                clave: formCargo._GetModelValue("ClaveProdServSAT"),
                                nombre: formCargo._DataOrigin.NombreProdServSAT,
                            },
                            unidad: {
                                clave: formCargo._GetModelValue("ClaveUnidadSAT"),
                                nombre: formCargo._DataOrigin.NombreUnidadSAT,
                            }
                        }

                    )
                    resolve(res.Resultado > 0);
                    return res;
                }
            }

            StepsConfig.push(CargoFormStep);
            StepsConfig.push(CargoAplicacionCalendar);
            StepsConfig.push(CargoInfoFinalStep);

            ModalThings._GetModalToALongProccess({
                Modulo: Entidad.CModulo.FinanzasCargo,
                Action: action,
                IdsEscuelas: [cargo.IdEscuela],
                StartEndIds: ["cargo", "cargo_info_final"],
                StepsConfig: StepsConfig,
                OnClose: () => resolve(false)
            })
        })
    }

    export function _DrawCalendar(content: TSelectionHTML<"div", any, any, any>) {
        let contInfo = content.select<HTMLDivElement>(".cont_info");

        let contentido = content.html(`
            <div class="cont_calendar"></div>
            <div class="cont_info"></div>
        `)
        contInfo = contentido.select(".cont_info"); // container.append("div").classed("cont_info", true);

        for (let i = 1; i <= 3; i++) {
            let tag = contInfo.append("div").classed("tag_" + i, true);
            tag.append("div").classed("selector", true).classed("sel_" + i, true);
            tag.append("div").classed("info", true).append("label");
        }
    }



    export function _GetStepCargoForm(): ModalThings.IConfigModalToALongProccessItem {
        return {
            Id: "cargo",
            Title: "",
            NextID: () => "cargo_periodicidad",
            Width: 500,
            OnDrawContent: (content, modalThings) => {
            },
        }
    }

    export function _GetStepCargoAplicacionCalendar(): ModalThings.IConfigModalToALongProccessItem {
        return {
            Id: "cargo_periodicidad",
            Title: "",
            NextID: () => "cargo_info_final",
            Width: 1100,
            PreviousID: "cargo",
            OnDrawContent: (content, modalThings) => {
            }
        }
    }

    export function _GetStepCargoInfoFinal(): ModalThings.IConfigModalToALongProccessItem {
        return {
            Id: "cargo_info_final",
            Title: "",
            PreviousID: "cargo_periodicidad",
            Width: 440,
            OnDrawContent: (content, mt) => {
            }
        }
    }

    type IFinanzaCargoExtended = TFinanzaCargoDataForm & { IdCicloEscolar?: number, DtAplicacion?: Date };

    export function _RenderCargoDescuentoDetails(dato: IFinanzaCargoExtended, container: HTMLElement) {
        const esDescuento = [CCategoriaTipoFinanza.Descuento].includes(dato.Categoria);
        if (esDescuento) {
            _RenderDescuentoDetails(dato, container);
        } else {
            _RenderCargoDetails(dato, container);
        }
    }

    export function _RenderCargoDetails(dato: IFinanzaCargoExtended, container: HTMLElement) {
        const idsEscuelas = dato.IdEscuela ? [dato.IdEscuela] : dato.IdEscuelas || [];
        const esCargoPreestablecidoHE: boolean = [CCategoriaTipoFinanza.CargoEntrada, CCategoriaTipoFinanza.CargoSalida].includes(dato.Categoria);
        const usaRecargo: boolean = dato.TipoRecargo != CTipoValor.Ninguno;
        const tieneFechaAplicacion: boolean = !!dato.DtAplicacion && (dato.DtAplicacion instanceof Date);
        const idEscuelaUsaFactura: number = idsEscuelas.find(id => !!_DICC_ESCUELA.get(id)?.UsaFactura) || 0; // const tieneInfoFiscal: boolean = (dato.IdAgrupador > 0 || !!dato.ClaveProdServSAT || !!dato.ClaveUnidadSAT || !!dato.ComplementoRequerido);
        const getAgrupadorCargo: () => IFinanzaAgrupadorCargos = () => (dato.IdAgrupador > 0 ? _DICC_AGRUPADORES_FULL.get(idEscuelaUsaFactura)?.get(dato.IdAgrupador) : null);
        const dtFechaVencimiento: Date | null = (() => {
            if (!tieneFechaAplicacion) return null;
            let dtFecha = new Date(dato.DtAplicacion);
            dtFecha.setDate(dtFecha.getDate() + dato.DiaVencimiento);
            return dtFecha;
        })();
        const dtFechaMorosidad: Date | null = (() => {
            if (!tieneFechaAplicacion) return null;
            let dtFecha = new Date(dtFechaVencimiento);
            dtFecha.setDate(dtFecha.getDate() + dato.DiaMorosidad);
            return dtFecha;
        })();

        if (!container["__haslistener"]) {
            container["__haslistener"] = true;
            MainPage
        }

        const renderContent = () => render(html`
        <div class="body_informacion">
            <label><b>${_L("finanzascargo.d_field_nombre")}</b>: ${dato.Nombre}
                <i style="font-family: Lato-Light;"> ${(esCargoPreestablecidoHE ? _L("finanzascargo.tag_cargo_preestablecido_info") : "")}</i>
            </label>
            <label><b>${_L("finanzascargo.d_field_valor")}</b>: ${esCargoPreestablecidoHE ? _L("finanzascargo.tag_cargo_pree_horae_val_info") : UIUtilFormat._CurrencyFmt(dato.Valor)}</label>
            <label><b>${_L("finanzascargo.tag_periodic")}</b>: ${UIUtilViewData._GetStr_Periodicidad(dato.Periodicidad)}</label>
            ${!tieneFechaAplicacion
                ? html`
            <label><b>${_L("finanzascargo.tag_dtaplica")}</b>: ${CreateDateDescription(dato.Periodicidad, "aplicacion", dato.MesAplicacion, dato.DiaAplicacion)}</label>
            <label><b>${_L("finanzascargo.tag_dtvence")}</b>: ${CreateDateDescription(dato.Periodicidad, "vencimiento", dato.MesAplicacion, dato.DiaVencimiento)}</label>
            <label><b>${_L("finanzascargo.tag_dtmoroso")}</b>: ${CreateDateDescription(dato.Periodicidad, "morosidad", dato.MesAplicacion, dato.DiaMorosidad)}</label>
                `
                : html`
            <label><b>${_L("finanzascargo.tag_dtaplica")}</b>: ${UIUtilTime._DateFormatStandar(dato.DtAplicacion, "d MMM yyyy")}</label>
            <label><b>${_L("finanzascargo.tag_dtvence")}</b>: ${UIUtilTime._DateFormatStandar(dtFechaVencimiento, "d MMM yyyy")}</label>
            <label><b>${_L("finanzascargo.tag_dtmoroso")}</b>: ${UIUtilTime._DateFormatStandar(dtFechaMorosidad, "d MMM yyyy")}</label>
                `
            }
            <label><b>${_L("finanzascargo.tag_recgs")}</b>: ${usaRecargo ? UIUtilViewFinanzaCargo._GetStrRecargosCol(dato) : _L("general.noaplica_short")}</label>
            ${dato.IdCicloEscolar
                ? html`<label><b>${_L("finanzascargo.tag_cicloesc")}</b>: ${DataModuloMain._GetDataValueFieldByName("CicloEscolar", dato.IdCicloEscolar, "Nombre") || _L("general.nodisponible")}</label>`
                : null
            }
            ${idEscuelaUsaFactura
                ? html`
            <label><b>${_L("general.nota")}</b>: ${_L("finanzascargo.tag_escuela_usa_fact", _DICC_ESCUELA.get(dato.IdEscuela)?.Nombre || "-")}</label>
            <fieldset class="info_fiscal_details">
                <legend>${_L("finanzascargo.frm1_cfg_fiscal")}</legend>
                <label><b>${_L("finanzascargo.frm1_agrupador")}</b>: ${dato.IdAgrupador > 0 ? getAgrupadorCargo()?.Prefix || _L("general.nodisponible") : _L("general.noaplica_short")}</label>
                <label><b>${_L("finanzascargo.frm1_claveprodservsat")}</b>: ${((dato.ClaveProdServSAT || "") + " " + (dato.NombreProdServSAT || "")) || _L("general.noaplica_short")}</label>
                <label><b>${_L("finanzascargo.frm1_claveunidadsat")}</b>: ${((dato.ClaveUnidadSAT || "") + " " + (dato.NombreUnidadSAT || "")) || _L("general.noaplica_short")}</label>
                <label><b>${_L("finanzascargo.frm1_complemento_iedu_requerido")}</b>: ${dato.ComplementoRequerido ? _L("general.afirma") : _L("general.niega")}</label>
            </fieldset>`
                : null
            }
        </div>
        `, container);

        renderContent();

        if (
            idEscuelaUsaFactura
            && dato.IdEscuela > 0// Disminuir probabilidad de consultar cuando sea una vista para Form
            && dato.IdAgrupador > 0
        ) {
            _SvFinanzasObtenerListaAgrupadorCargosByIds(dato.IdEscuela, [dato.IdAgrupador]).then(() => {
                renderContent();
            })
        }
    }

    type IFinanzaCargoDescuentoDetails = Pick<IFinanzaCargo, "Nombre" | "Valor" | "TipoValor">;
    export function _RenderDescuentoDetails(dato: IFinanzaCargoDescuentoDetails, container: HTMLElement) {
        render(html`
        <div class="body_informacion">
            <label><b>${_L("finanzascargo.d_field_nombre")}</b>: ${dato.Nombre}</label>
            <label><b>${_L("finanzascargo.d_field_valor")}</b>: ${dato.TipoValor == CTipoValor.Porcentaje ? UIUtilFormat._PercentFmt(dato.Valor) : UIUtilFormat._CurrencyFmt(dato.Valor)}</label>
            <label><b>${_L("finanzascargo.tag_tipo")}</b>: ${UIUtilViewData._GetStr_TipoValor(dato.TipoValor)}</label>
        </div>
        `, container);
    }

    /** Devuelve una cadena descriptiva de la fecha según la periodicidad y el tipo de fecha (aplicacion, vencimiento, morosidad)
     * @param periodicidad
     * @param namePeriodicidad
     * @param nMes
     * @param nPrincipal
     * @example CreateDateDescription(CPeriodicidadCargos.Mensual, "aplicacion", 0, 15) => "Se aplica el día 15 de cada mes"
     * @return string
    */
    function CreateDateDescription(periodicidad: CPeriodicidadCargos, namePeriodicidad: ("aplicacion" | "vencimiento" | "morosidad"), nMes: number, nPrincipal: number): string {
        const fnGetTalLang = (str: string) => UIUtilLang._GetUIString(langContextModuleFCargo, str);
        let strTag = "";

        switch (namePeriodicidad) {
            case "aplicacion":
                switch (periodicidad) {
                    case CPeriodicidadCargos.Mensual:
                        strTag += fnGetTalLang("tag_aplicames")
                            .replace("_NDIA", nPrincipal.toString());
                        break;
                    case CPeriodicidadCargos.Unico:
                        strTag += fnGetTalLang("tag_aplicaunico");
                        break;
                    default:
                        strTag += fnGetTalLang("tag_aplicaotro")
                            .replace("_NDIA", nPrincipal.toString())
                            .replace("_NMES", nMes.toString())
                            .replace("_PERIODO", UIUtilViewData._GetStr_Periodicidad(periodicidad));
                        break;
                }
                break;
            case "vencimiento":
                if (nPrincipal == 0) {
                    strTag += fnGetTalLang("tag_venceenaplica");
                }
                else {
                    strTag += fnGetTalLang("tag_vencedespaplica")
                        .replace("_DIA", nPrincipal.toString());
                }
                break;
            case "morosidad":
                if (nPrincipal == 0) {
                    strTag += fnGetTalLang("tag_morosoenvence");
                }
                else {
                    strTag += fnGetTalLang("tag_morosodespvence")
                        .replace("_DIA", nPrincipal.toString());
                }
                break;
        }
        return strTag;
    }

    export function _ApplyTypeValueToInputValue<T extends IFinanzaCargo>(typeValue: CTipoValor, modelBase: "valorCargo" | "valorRecargo", form: FormGenerator<T>) { //: d3.Selection<HTMLDivElement, any, HTMLElement, any> {
        // let itemFormRadioTipoValor = form.prop_ControlsData.get(modelBase == "valorCargo" ? CFormModels.TipoValor : CFormModels.TipoRecargo);
        const itemFormInputValor = form._GetModelControl<"input">(modelBase == "valorCargo" ? CFinanzaCargoFormField.Valor : CFinanzaCargoFormField.ValorRecargo);

        if (itemFormInputValor?.selection.node()) {
            const containerInputValue = select(itemFormInputValor.selection.node().parentElement as HTMLDivElement);
            const esValorPorcentaje = typeValue == CTipoValor.Porcentaje

            itemFormInputValor.selection
                .attr("max", esValorPorcentaje ? 100 : null)
                .attr("step", ".01")

            if (modelBase == "valorRecargo") {
                const generaInteres = [CTipoInteres.Simple, CTipoInteres.Compuesto].includes(form._GetModelValue(CFinanzaCargoFormField.TipoInteres))
                const esRecargoDiario = (esValorPorcentaje && form._GetModelValue(CFinanzaCargoFormField.IntervaloBloque) == CFinanzasCargoRecurrenciaRecargo.Diaria)
                const tieneRecurrencia = (esValorPorcentaje && generaInteres) || typeValue == CTipoValor.Monto
                itemFormInputValor.row.classed("hide", (typeValue == CTipoValor.Ninguno));
                form._GetModelControl(CFinanzaCargoFormField.TipoInteres).row.classed("hide", !esValorPorcentaje);
                form._GetModelControl(CFinanzaCargoFormField.IntervaloBloque).row.classed("hide", !tieneRecurrencia);
                form._GetModelControl(CFinanzaCargoFormField.TipoTasa)?.row.classed("hide", !esRecargoDiario);
            }

            // if (applyRadioListInput) {
            //     (itemFormRadioTipoValor.instance as RadioList)?.met_valueCheck(typeValue + "");
            // }

            let symbolElement = containerInputValue.select(".input_symbol");
            if (!symbolElement.node()) {
                symbolElement = containerInputValue.append("div").classed("input_symbol", true)
                symbolElement.append("span");
            }
            symbolElement = symbolElement.select("span");

            if (typeValue == CTipoValor.Monto) {
                containerInputValue.classed("input_currency", true);
                containerInputValue.classed("input_percent", false);
                symbolElement.text("$");
            } else if (esValorPorcentaje) {
                containerInputValue.classed("input_currency", false);
                containerInputValue.classed("input_percent", true);
                symbolElement.text("%");
            }
        }
    }
}
